import React from 'react';
import styles from "./styles.module.css.js";
export var ResultItem = _ref => {
  var {
    result,
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.ResultItem,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("h2", null, result.locationName), /*#__PURE__*/React.createElement("span", null, result.lat, ", ", result.lng));
};
export default ResultItem;
//# sourceMappingURL=index.js.map